import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import styles from './index.styl';

const DescriptionSection = ({ description, links }) => {
  return (
    <div className={styles.section}>
      <p className="mb2">{description}</p>
      <If condition={!isEmpty(links)}>
        {links.map(link => (
          <a
            href={get(link, 'urlLink')}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
            key={get(link, 'id')}
          >
            {get(link, 'urlDescription')}
          </a>
        ))}
      </If>
    </div>
  );
};

DescriptionSection.propTypes = {
  description: PropTypes.string,
  links: PropTypes.array,
};

export default DescriptionSection;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/components/common/DescriptionSection/index.jsx